/* tslint:disable */
/* eslint-disable */
/**
 * cerere
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.1-DROP2-SNAPSHOT 2024-09-12T09:47:12Z
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActivateContractRequest
 */
export interface ActivateContractRequest {
    /**
     * registration process id
     * @type {string}
     * @memberof ActivateContractRequest
     */
    'processId': string;
    /**
     * customer code of physical person, company or trust company
     * @type {string}
     * @memberof ActivateContractRequest
     */
    'customerCode': string;
}
/**
 * addressType: RES-Residenza, COR-Corrispondenza, DOM-Domicilio
 * @export
 * @enum {string}
 */

export const AddressType = {
    Res: 'RES',
    Cor: 'COR',
    Dom: 'DOM'
} as const;

export type AddressType = typeof AddressType[keyof typeof AddressType];


/**
 * object result
 * @export
 * @interface AgentDataResponse
 */
export interface AgentDataResponse {
    /**
     * Agent code
     * @type {string}
     * @memberof AgentDataResponse
     */
    'agentCode'?: string;
    /**
     * agent nominative
     * @type {string}
     * @memberof AgentDataResponse
     */
    'nominative'?: string;
}
/**
 * 
 * @export
 * @interface ChangeContactRequest
 */
export interface ChangeContactRequest {
    /**
     * Customer code
     * @type {string}
     * @memberof ChangeContactRequest
     */
    'customerCode': string;
    /**
     * BehalfOf code, required for company subject
     * @type {string}
     * @memberof ChangeContactRequest
     */
    'behalfOfCode'?: string;
    /**
     * User contact for digital signature
     * @type {boolean}
     * @memberof ChangeContactRequest
     */
    'digitalSignatureContact': boolean;
    /**
     * User contacts data, one per contact type, at least one
     * @type {Array<ContactData>}
     * @memberof ChangeContactRequest
     */
    'customerContacts': Array<ContactData>;
}
/**
 * object result
 * @export
 * @interface ChangeContactResponse
 */
export interface ChangeContactResponse {
    /**
     * 
     * @type {DocumentData}
     * @memberof ChangeContactResponse
     */
    'document'?: DocumentData;
}
/**
 * dealer company
 * @export
 * @interface CompanyData
 */
export interface CompanyData {
    /**
     * code
     * @type {string}
     * @memberof CompanyData
     */
    'code'?: string;
    /**
     * description
     * @type {string}
     * @memberof CompanyData
     */
    'description'?: string;
    /**
     * type
     * @type {string}
     * @memberof CompanyData
     */
    'type'?: string;
}
/**
 * object result
 * @export
 * @interface Composition
 */
export interface Composition {
    /**
     * composition group
     * @type {{ [key: string]: GroupData; }}
     * @memberof Composition
     */
    'groups'?: { [key: string]: GroupData; };
    /**
     * total composition group
     * @type {number}
     * @memberof Composition
     */
    'total'?: number;
}
/**
 * compositionType: PRODUCT - Prodotto, PRODUCT_TYPE - Tipo Prodotto PRODUCT_MACRO_CATEGORY - Macro categoria prodotto, DURATION - Duration
 * @export
 * @enum {string}
 */

export const CompositionType = {
    Product: 'PRODUCT',
    Producttype: 'PRODUCTTYPE',
    Productmacrocategory: 'PRODUCTMACROCATEGORY',
    Duration: 'DURATION'
} as const;

export type CompositionType = typeof CompositionType[keyof typeof CompositionType];


/**
 * User contacts data, one per contact type, at least one
 * @export
 * @interface ContactData
 */
export interface ContactData {
    /**
     * User contact type
     * @type {string}
     * @memberof ContactData
     */
    'contactType'?: ContactDataContactTypeEnum;
    /**
     * User contact
     * @type {string}
     * @memberof ContactData
     */
    'contact'?: string;
    /**
     * User old contact
     * @type {string}
     * @memberof ContactData
     */
    'oldContact'?: string;
}

export const ContactDataContactTypeEnum = {
    Email: 'EMAIL',
    Phone: 'PHONE'
} as const;

export type ContactDataContactTypeEnum = typeof ContactDataContactTypeEnum[keyof typeof ContactDataContactTypeEnum];

/**
 * 
 * @export
 * @interface ContactInfoRequest
 */
export interface ContactInfoRequest {
    /**
     * registration process id
     * @type {string}
     * @memberof ContactInfoRequest
     */
    'processId': string;
    /**
     * customer code
     * @type {string}
     * @memberof ContactInfoRequest
     */
    'customerCode': string;
    /**
     * User contact type
     * @type {string}
     * @memberof ContactInfoRequest
     */
    'contactType': ContactInfoRequestContactTypeEnum;
    /**
     * contact
     * @type {string}
     * @memberof ContactInfoRequest
     */
    'contact': string;
    /**
     * contact for digital signature
     * @type {boolean}
     * @memberof ContactInfoRequest
     */
    'digitalSignatureContact': boolean;
}

export const ContactInfoRequestContactTypeEnum = {
    Email: 'EMAIL',
    Phone: 'PHONE'
} as const;

export type ContactInfoRequestContactTypeEnum = typeof ContactInfoRequestContactTypeEnum[keyof typeof ContactInfoRequestContactTypeEnum];

/**
 * 
 * @export
 * @interface ContactRequest
 */
export interface ContactRequest {
    /**
     * customer code
     * @type {string}
     * @memberof ContactRequest
     */
    'customerCode': string;
    /**
     * User contact type
     * @type {string}
     * @memberof ContactRequest
     */
    'contactType': ContactRequestContactTypeEnum;
    /**
     * User contact
     * @type {string}
     * @memberof ContactRequest
     */
    'contact': string;
    /**
     * contact for digital signature
     * @type {boolean}
     * @memberof ContactRequest
     */
    'digitalSignatureContact': boolean;
}

export const ContactRequestContactTypeEnum = {
    Email: 'EMAIL',
    Phone: 'PHONE'
} as const;

export type ContactRequestContactTypeEnum = typeof ContactRequestContactTypeEnum[keyof typeof ContactRequestContactTypeEnum];

/**
 * customer portfolio contracts
 * @export
 * @interface ContractPortfolioData
 */
export interface ContractPortfolioData {
    /**
     * contract code
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'code'?: string;
    /**
     * paper contract number
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'paperContractNumber'?: string;
    /**
     * supplier company reference number
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'suppCompanyRefNum'?: string;
    /**
     * dossier code
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'dossierCode'?: string;
    /**
     * total amount
     * @type {number}
     * @memberof ContractPortfolioData
     */
    'amount'?: number;
    /**
     * total investment gross amount
     * @type {number}
     * @memberof ContractPortfolioData
     */
    'investmentsGrossAmount'?: number;
    /**
     * total disinvestments gross amount
     * @type {number}
     * @memberof ContractPortfolioData
     */
    'disinvestmentsGrossAmount'?: number;
    /**
     * total switch out gross amount
     * @type {number}
     * @memberof ContractPortfolioData
     */
    'switchOutGrossAmount'?: number;
    /**
     * total switch in gross amount
     * @type {number}
     * @memberof ContractPortfolioData
     */
    'switchInGrossAmount'?: number;
    /**
     * total paidAmount (investments and disinvestments)
     * @type {number}
     * @memberof ContractPortfolioData
     */
    'paidAmount'?: number;
    /**
     * currency
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'currency'?: string;
    /**
     * contract type code
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'type'?: string;
    /**
     * subscription type code
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'subscriptionTypeCode'?: string;
    /**
     * operational status code
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'operationalStatusCode'?: string;
    /**
     * commitment
     * @type {number}
     * @memberof ContractPortfolioData
     */
    'commitment'?: number;
    /**
     * context Rto
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'contextRto'?: string;
    /**
     * company description
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'companyDescription'?: string;
    /**
     * saving plan PIR
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'savingPlan'?: string;
    /**
     * contract macro product code
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'contractMacroProductCode'?: string;
    /**
     * contract macro product description
     * @type {string}
     * @memberof ContractPortfolioData
     */
    'contractMacroProductDescription'?: string;
    /**
     * contract position list
     * @type {Set<PositionData>}
     * @memberof ContractPortfolioData
     */
    'positions'?: Set<PositionData>;
}
/**
 * document data list
 * @export
 * @interface DocumentData
 */
export interface DocumentData {
    /**
     * document identifier
     * @type {string}
     * @memberof DocumentData
     */
    'documentId'?: string;
    /**
     * 
     * @type {DocumentType}
     * @memberof DocumentData
     */
    'documentType'?: DocumentType;
    /**
     * number of contract
     * @type {string}
     * @memberof DocumentData
     */
    'contractNumber'?: string;
}
/**
 * documentType: SUBSCRIPTION - Sottoscrizione Servizi Digitali, ADDENDUM_SUBSCRIPTION - Addendum Sottoscrizione Servizi Digitali, CHANGE_CONTACTS - Cambio Recapiti
 * @export
 * @enum {string}
 */

export const DocumentType = {
    Subscription: 'SUBSCRIPTION',
    AddendumSubscription: 'ADDENDUM_SUBSCRIPTION',
    ChangeContacts: 'CHANGE_CONTACTS'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];


/**
 * composition group
 * @export
 * @interface GroupData
 */
export interface GroupData {
    /**
     * code
     * @type {string}
     * @memberof GroupData
     */
    'code'?: string;
    /**
     * description
     * @type {string}
     * @memberof GroupData
     */
    'description'?: string;
    /**
     * value
     * @type {number}
     * @memberof GroupData
     */
    'value'?: number;
    /**
     * percentage
     * @type {number}
     * @memberof GroupData
     */
    'percentage'?: number;
}
/**
 * object result
 * @export
 * @interface InfoServiceBean
 */
export interface InfoServiceBean {
    /**
     * 
     * @type {string}
     * @memberof InfoServiceBean
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoServiceBean
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface InformativeVerificationRequest
 */
export interface InformativeVerificationRequest {
    /**
     * registration process id
     * @type {string}
     * @memberof InformativeVerificationRequest
     */
    'processId': string;
    /**
     * customer code of physical person, company or trust company
     * @type {string}
     * @memberof InformativeVerificationRequest
     */
    'customerCode': string;
    /**
     * Opt-in/out marketing campaign, yes/no
     * @type {boolean}
     * @memberof InformativeVerificationRequest
     */
    'accepted': boolean;
    /**
     * privacy policy acceptance
     * @type {boolean}
     * @memberof InformativeVerificationRequest
     */
    'privacyPolicyCheck': boolean;
}
/**
 * object result
 * @export
 * @interface LinkedSubject
 */
export interface LinkedSubject {
    /**
     * Customer code of linked subject
     * @type {string}
     * @memberof LinkedSubject
     */
    'linkedSubjectCode'?: string;
    /**
     * 
     * @type {LinkedSubjectType}
     * @memberof LinkedSubject
     */
    'linkedSubjectType'?: LinkedSubjectType;
    /**
     * Customer code of company
     * @type {string}
     * @memberof LinkedSubject
     */
    'customerCode'?: string;
}
/**
 * LinkedSubjectType: LEGAL_REPRESENTATIVE - Rappresentante Legale, PROSECUTOR - Procuratore BENEFICIAL_OWNER - Titolare Effettivo)
 * @export
 * @enum {string}
 */

export const LinkedSubjectType = {
    LegalRepresentative: 'LEGAL_REPRESENTATIVE',
    Prosecutor: 'PROSECUTOR',
    BeneficialOwner: 'BENEFICIAL_OWNER'
} as const;

export type LinkedSubjectType = typeof LinkedSubjectType[keyof typeof LinkedSubjectType];


/**
 * macro product
 * @export
 * @interface MacroProductData
 */
export interface MacroProductData {
    /**
     * code
     * @type {string}
     * @memberof MacroProductData
     */
    'code'?: string;
    /**
     * description
     * @type {string}
     * @memberof MacroProductData
     */
    'description'?: string;
    /**
     * mono product
     * @type {boolean}
     * @memberof MacroProductData
     */
    'monoProduct'?: boolean;
    /**
     * 
     * @type {MacroProductFamilyData}
     * @memberof MacroProductData
     */
    'family'?: MacroProductFamilyData;
}
/**
 * macro product family
 * @export
 * @interface MacroProductFamilyData
 */
export interface MacroProductFamilyData {
    /**
     * code
     * @type {string}
     * @memberof MacroProductFamilyData
     */
    'code'?: string;
}
/**
 * check results
 * @export
 * @interface MonitoringCheckResult
 */
export interface MonitoringCheckResult {
    /**
     * result code
     * @type {string}
     * @memberof MonitoringCheckResult
     */
    'resultCode'?: string;
    /**
     * check type
     * @type {string}
     * @memberof MonitoringCheckResult
     */
    'checkType'?: string;
    /**
     * value
     * @type {number}
     * @memberof MonitoringCheckResult
     */
    'value'?: number;
    /**
     * threshold value
     * @type {number}
     * @memberof MonitoringCheckResult
     */
    'thresholdValue'?: number;
}
/**
 * object result
 * @export
 * @interface MonitoringResult
 */
export interface MonitoringResult {
    /**
     * result
     * @type {number}
     * @memberof MonitoringResult
     */
    'result'?: number;
    /**
     * result code
     * @type {string}
     * @memberof MonitoringResult
     */
    'resultCode'?: string;
    /**
     * result message
     * @type {string}
     * @memberof MonitoringResult
     */
    'resultMessage'?: string;
    /**
     * check results
     * @type {Array<MonitoringCheckResult>}
     * @memberof MonitoringResult
     */
    'checkResults'?: Array<MonitoringCheckResult>;
}
/**
 * object result
 * @export
 * @interface MovementData
 */
export interface MovementData {
    /**
     * movement code
     * @type {string}
     * @memberof MovementData
     */
    'code'?: string;
    /**
     * position code
     * @type {string}
     * @memberof MovementData
     */
    'positionCode'?: string;
    /**
     * date
     * @type {string}
     * @memberof MovementData
     */
    'date'?: string;
    /**
     * settlment date
     * @type {string}
     * @memberof MovementData
     */
    'settlementDate'?: string;
    /**
     * currency date
     * @type {string}
     * @memberof MovementData
     */
    'currencyDate'?: string;
    /**
     * transaction type
     * @type {string}
     * @memberof MovementData
     */
    'transactionType'?: string;
    /**
     * reason for payment
     * @type {string}
     * @memberof MovementData
     */
    'reasonForPayment'?: string;
    /**
     * gross amount
     * @type {number}
     * @memberof MovementData
     */
    'grossAmount'?: number;
    /**
     * internal fee
     * @type {number}
     * @memberof MovementData
     */
    'internalFee'?: number;
    /**
     * taxes
     * @type {number}
     * @memberof MovementData
     */
    'taxes'?: number;
    /**
     * external fee
     * @type {number}
     * @memberof MovementData
     */
    'externalFee'?: number;
    /**
     * price
     * @type {number}
     * @memberof MovementData
     */
    'price'?: number;
    /**
     * currency
     * @type {string}
     * @memberof MovementData
     */
    'currency'?: string;
    /**
     * original price
     * @type {number}
     * @memberof MovementData
     */
    'originalPrice'?: number;
    /**
     * original currency
     * @type {string}
     * @memberof MovementData
     */
    'originalCurrency'?: string;
    /**
     * net amount
     * @type {number}
     * @memberof MovementData
     */
    'netAmount'?: number;
    /**
     * quantity
     * @type {number}
     * @memberof MovementData
     */
    'quantity'?: number;
    /**
     * exchange
     * @type {number}
     * @memberof MovementData
     */
    'exchange'?: number;
    /**
     * exchange date
     * @type {string}
     * @memberof MovementData
     */
    'exchangeDate'?: string;
}
/**
 * 
 * @export
 * @interface MovementRequest
 */
export interface MovementRequest {
    /**
     * customer code
     * @type {string}
     * @memberof MovementRequest
     */
    'customerCode': string;
    /**
     * contract code
     * @type {string}
     * @memberof MovementRequest
     */
    'contractCode': string;
    /**
     * list of position codes
     * @type {Array<string>}
     * @memberof MovementRequest
     */
    'positionCodeList': Array<string>;
    /**
     * from date
     * @type {string}
     * @memberof MovementRequest
     */
    'fromDate'?: string;
    /**
     * to date
     * @type {string}
     * @memberof MovementRequest
     */
    'toDate'?: string;
}
/**
 * object result
 * @export
 * @interface PermissionServiceBean
 */
export interface PermissionServiceBean {
    /**
     * 
     * @type {string}
     * @memberof PermissionServiceBean
     */
    'name'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof PermissionServiceBean
     */
    'permissions'?: Set<string>;
}
/**
 * User addresses
 * @export
 * @interface PersonalAddressData
 */
export interface PersonalAddressData {
    /**
     * 
     * @type {AddressType}
     * @memberof PersonalAddressData
     */
    'addressType'?: AddressType;
    /**
     * User address
     * @type {string}
     * @memberof PersonalAddressData
     */
    'address'?: string;
    /**
     * User address city
     * @type {string}
     * @memberof PersonalAddressData
     */
    'city'?: string;
    /**
     * User address zip code
     * @type {string}
     * @memberof PersonalAddressData
     */
    'zipCode'?: string;
    /**
     * User address province
     * @type {string}
     * @memberof PersonalAddressData
     */
    'province'?: string;
    /**
     * User address country
     * @type {string}
     * @memberof PersonalAddressData
     */
    'country'?: string;
}
/**
 * User contacts
 * @export
 * @interface PersonalContactData
 */
export interface PersonalContactData {
    /**
     * User contact type
     * @type {string}
     * @memberof PersonalContactData
     */
    'contactType'?: string;
    /**
     * User contact
     * @type {string}
     * @memberof PersonalContactData
     */
    'contact'?: string;
    /**
     * Contact for digital signature
     * @type {boolean}
     * @memberof PersonalContactData
     */
    'digitalSignatureContact'?: boolean;
}
/**
 * object result
 * @export
 * @interface PersonalDataResponse
 */
export interface PersonalDataResponse {
    /**
     * 
     * @type {PersonalGeneralInfoData}
     * @memberof PersonalDataResponse
     */
    'generalInfo'?: PersonalGeneralInfoData;
    /**
     * User addresses
     * @type {Array<PersonalAddressData>}
     * @memberof PersonalDataResponse
     */
    'addresses'?: Array<PersonalAddressData>;
    /**
     * User documents
     * @type {Array<PersonalDocumentData>}
     * @memberof PersonalDataResponse
     */
    'documents'?: Array<PersonalDocumentData>;
    /**
     * User contacts
     * @type {Array<PersonalContactData>}
     * @memberof PersonalDataResponse
     */
    'contacts'?: Array<PersonalContactData>;
}
/**
 * User documents
 * @export
 * @interface PersonalDocumentData
 */
export interface PersonalDocumentData {
    /**
     * Document type
     * @type {string}
     * @memberof PersonalDocumentData
     */
    'documentType'?: string;
    /**
     * Document code
     * @type {string}
     * @memberof PersonalDocumentData
     */
    'documentCode'?: string;
    /**
     * Document released by
     * @type {string}
     * @memberof PersonalDocumentData
     */
    'releasedBy'?: string;
    /**
     * Document released date
     * @type {string}
     * @memberof PersonalDocumentData
     */
    'releaseDate'?: string;
    /**
     * Document expiration date
     * @type {string}
     * @memberof PersonalDocumentData
     */
    'expirationDate'?: string;
    /**
     * document released city
     * @type {string}
     * @memberof PersonalDocumentData
     */
    'releaseCity'?: string;
    /**
     * document release province
     * @type {string}
     * @memberof PersonalDocumentData
     */
    'releaseProvince'?: string;
    /**
     * document released country
     * @type {string}
     * @memberof PersonalDocumentData
     */
    'releaseCountry'?: string;
}
/**
 * User general info
 * @export
 * @interface PersonalGeneralInfoData
 */
export interface PersonalGeneralInfoData {
    /**
     * User code
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'customerCode'?: string;
    /**
     * User first name
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'firstName'?: string;
    /**
     * User last name
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'lastName'?: string;
    /**
     * User nominative
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'fullName'?: string;
    /**
     * User gender
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'gender'?: string;
    /**
     * User birthdate
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'dateOfBirth'?: string;
    /**
     * User birth city
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'birthCity'?: string;
    /**
     * User birth province
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'birthProvince'?: string;
    /**
     * User birth country
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'birthCountry'?: string;
    /**
     * User citizenship
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'citizenship'?: string;
    /**
     * User tax code / VAT number
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'taxCode'?: string;
    /**
     * Company type
     * @type {string}
     * @memberof PersonalGeneralInfoData
     */
    'companyType'?: string;
}
/**
 * object result
 * @export
 * @interface PirDepositDetailBean
 */
export interface PirDepositDetailBean {
    /**
     * Customer code
     * @type {string}
     * @memberof PirDepositDetailBean
     */
    'customerCode'?: string;
    /**
     * PIR code
     * @type {string}
     * @memberof PirDepositDetailBean
     */
    'pirCode'?: string;
    /**
     * PIR type
     * @type {string}
     * @memberof PirDepositDetailBean
     */
    'pirType'?: string;
    /**
     * PIR open date
     * @type {string}
     * @memberof PirDepositDetailBean
     */
    'pirOpenDate'?: string;
    /**
     * PIR closing date
     * @type {string}
     * @memberof PirDepositDetailBean
     */
    'pirClosingDate'?: string;
    /**
     * PIR status
     * @type {string}
     * @memberof PirDepositDetailBean
     */
    'status'?: string;
    /**
     * Pir detail info in format map<string,PirDetailBean>, field subtype: \'application/json\'
     * @type {{ [key: string]: PirDetailBean; }}
     * @memberof PirDepositDetailBean
     */
    'pirDetailMap'?: { [key: string]: PirDetailBean; };
    /**
     * PIR Commitment
     * @type {number}
     * @memberof PirDepositDetailBean
     */
    'commitment'?: number;
    /**
     * Total PIR buy operation
     * @type {number}
     * @memberof PirDepositDetailBean
     */
    'totalBuy'?: number;
    /**
     * Total PIR sell operation
     * @type {number}
     * @memberof PirDepositDetailBean
     */
    'totalSell'?: number;
    /**
     * Total PIR investment operation
     * @type {number}
     * @memberof PirDepositDetailBean
     */
    'totalInvestment'?: number;
    /**
     * PIR max amount to invest
     * @type {number}
     * @memberof PirDepositDetailBean
     */
    'maxAmount'?: number;
    /**
     * PIR max amount to invest / year
     * @type {number}
     * @memberof PirDepositDetailBean
     */
    'yearlyMaxAmount'?: number;
    /**
     * PIR residual amount to be invested
     * @type {number}
     * @memberof PirDepositDetailBean
     */
    'residualAmount'?: number;
    /**
     * PIR residual amount to be invested / year
     * @type {number}
     * @memberof PirDepositDetailBean
     */
    'yearlyResidualAmount'?: number;
    /**
     * PIR lost benefit date
     * @type {string}
     * @memberof PirDepositDetailBean
     */
    'lostBenefitDate'?: string;
}
/**
 * Pir detail info in format map<string,PirDetailBean>, field subtype: \'application/json\'
 * @export
 * @interface PirDetailBean
 */
export interface PirDetailBean {
    /**
     * Composition weight
     * @type {number}
     * @memberof PirDetailBean
     */
    'weight'?: number;
    /**
     * Total PIR composition buy operation
     * @type {number}
     * @memberof PirDetailBean
     */
    'totalBuy'?: number;
    /**
     * Total PIR composition sell operation
     * @type {number}
     * @memberof PirDetailBean
     */
    'totalSell'?: number;
    /**
     * Total PIR composition investment operation
     * @type {number}
     * @memberof PirDetailBean
     */
    'totalInvestment'?: number;
    /**
     * PIR position information list<string>
     * @type {Array<PirPositionBean>}
     * @memberof PirDetailBean
     */
    'positions'?: Array<PirPositionBean>;
}
/**
 * Pir year indicator info in format map<string,PirIndicatorBean>, field subtype: \'application/json\'
 * @export
 * @interface PirIndicatorBean
 */
export interface PirIndicatorBean {
    /**
     * PIR amount invested
     * @type {number}
     * @memberof PirIndicatorBean
     */
    'amount'?: number;
    /**
     * PIR max amount to be invested
     * @type {number}
     * @memberof PirIndicatorBean
     */
    'maxInvestmentAmount'?: number;
}
/**
 * Position movements information list<string>
 * @export
 * @interface PirMovementBean
 */
export interface PirMovementBean {
    /**
     * Code
     * @type {string}
     * @memberof PirMovementBean
     */
    'code'?: string;
    /**
     * Commitment
     * @type {number}
     * @memberof PirMovementBean
     */
    'commitment'?: number;
    /**
     * Movement date
     * @type {string}
     * @memberof PirMovementBean
     */
    'movementDate'?: string;
    /**
     * Invested
     * @type {number}
     * @memberof PirMovementBean
     */
    'invested'?: number;
    /**
     * Disinvested
     * @type {number}
     * @memberof PirMovementBean
     */
    'disinvested'?: number;
    /**
     * Quantity
     * @type {number}
     * @memberof PirMovementBean
     */
    'quantity'?: number;
    /**
     * Price
     * @type {number}
     * @memberof PirMovementBean
     */
    'price'?: number;
    /**
     * Currency
     * @type {string}
     * @memberof PirMovementBean
     */
    'currency'?: string;
    /**
     * HoldingPeriod
     * @type {string}
     * @memberof PirMovementBean
     */
    'holdingPeriod'?: string;
}
/**
 * PIR position information list<string>
 * @export
 * @interface PirPositionBean
 */
export interface PirPositionBean {
    /**
     * Product code
     * @type {string}
     * @memberof PirPositionBean
     */
    'productCode'?: string;
    /**
     * Product description
     * @type {string}
     * @memberof PirPositionBean
     */
    'productName'?: string;
    /**
     * Contract code
     * @type {string}
     * @memberof PirPositionBean
     */
    'contractCode'?: string;
    /**
     * Currency
     * @type {string}
     * @memberof PirPositionBean
     */
    'currency'?: string;
    /**
     * Cmp
     * @type {number}
     * @memberof PirPositionBean
     */
    'cmp'?: number;
    /**
     * Commitment
     * @type {number}
     * @memberof PirPositionBean
     */
    'commitment'?: number;
    /**
     * Quantity
     * @type {number}
     * @memberof PirPositionBean
     */
    'quantity'?: number;
    /**
     * Total position buy operation
     * @type {number}
     * @memberof PirPositionBean
     */
    'totalBuy'?: number;
    /**
     * Total position sell operation
     * @type {number}
     * @memberof PirPositionBean
     */
    'totalSell'?: number;
    /**
     * Total position amount
     * @type {number}
     * @memberof PirPositionBean
     */
    'amountTotal'?: number;
    /**
     * Position movements information list<string>
     * @type {Array<PirMovementBean>}
     * @memberof PirPositionBean
     */
    'movements'?: Array<PirMovementBean>;
    /**
     * compliant
     * @type {boolean}
     * @memberof PirPositionBean
     */
    'compliant'?: boolean;
    /**
     * Position weight
     * @type {number}
     * @memberof PirPositionBean
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface PortfolioPerformanceRequest
 */
export interface PortfolioPerformanceRequest {
    /**
     * customer code of physical person, company or trust company
     * @type {string}
     * @memberof PortfolioPerformanceRequest
     */
    'customerCode': string;
    /**
     * List of portfolio dossiers code
     * @type {Array<string>}
     * @memberof PortfolioPerformanceRequest
     */
    'dossierCodeList'?: Array<string>;
    /**
     * List of portfolio contract code
     * @type {Array<string>}
     * @memberof PortfolioPerformanceRequest
     */
    'contractCodeList'?: Array<string>;
    /**
     * Product category
     * @type {string}
     * @memberof PortfolioPerformanceRequest
     */
    'category'?: PortfolioPerformanceRequestCategoryEnum;
    /**
     * interval analysis
     * @type {string}
     * @memberof PortfolioPerformanceRequest
     */
    'intervalAnalysis'?: PortfolioPerformanceRequestIntervalAnalysisEnum;
    /**
     * Analisys start date
     * @type {string}
     * @memberof PortfolioPerformanceRequest
     */
    'startDate'?: string;
    /**
     * Analisys end date
     * @type {string}
     * @memberof PortfolioPerformanceRequest
     */
    'endDate'?: string;
}

export const PortfolioPerformanceRequestCategoryEnum = {
    Managed: 'MANAGED',
    Administered: 'ADMINISTERED',
    RealEconomy: 'REAL_ECONOMY',
    Welfare: 'WELFARE'
} as const;

export type PortfolioPerformanceRequestCategoryEnum = typeof PortfolioPerformanceRequestCategoryEnum[keyof typeof PortfolioPerformanceRequestCategoryEnum];
export const PortfolioPerformanceRequestIntervalAnalysisEnum = {
    Interval: 'PERF_INTERVAL',
    FromInitialYear: 'PERF_FROM_INITIAL_YEAR',
    FromOneYear: 'PERF_FROM_ONE_YEAR',
    FromOpening: 'PERF_FROM_OPENING'
} as const;

export type PortfolioPerformanceRequestIntervalAnalysisEnum = typeof PortfolioPerformanceRequestIntervalAnalysisEnum[keyof typeof PortfolioPerformanceRequestIntervalAnalysisEnum];

/**
 * object result
 * @export
 * @interface PortfolioPerformanceResponse
 */
export interface PortfolioPerformanceResponse {
    /**
     * the performance value of portfolio
     * @type {number}
     * @memberof PortfolioPerformanceResponse
     */
    'performance'?: number;
    /**
     * the total amount of portfolio
     * @type {number}
     * @memberof PortfolioPerformanceResponse
     */
    'totalValue'?: number;
    /**
     * the currency of total portfolio amount
     * @type {string}
     * @memberof PortfolioPerformanceResponse
     */
    'currency'?: string;
    /**
     * the list of products performance 
     * @type {Array<ProductPerformance>}
     * @memberof PortfolioPerformanceResponse
     */
    'performances'?: Array<ProductPerformance>;
}
/**
 * 
 * @export
 * @interface PortfolioRequest
 */
export interface PortfolioRequest {
    /**
     * customer code of physical person, company or trust company
     * @type {string}
     * @memberof PortfolioRequest
     */
    'customerCode': string;
    /**
     * customer as first holder
     * @type {boolean}
     * @memberof PortfolioRequest
     */
    'firstHolder'?: boolean;
}
/**
 * object result
 * @export
 * @interface PortfolioResponse
 */
export interface PortfolioResponse {
    /**
     * customer code portfolio dossiers
     * @type {string}
     * @memberof PortfolioResponse
     */
    'customerCode'?: string;
    /**
     * customer portfolio contracts
     * @type {Set<ContractPortfolioData>}
     * @memberof PortfolioResponse
     */
    'contracts'?: Set<ContractPortfolioData>;
    /**
     * portfolio total amount
     * @type {number}
     * @memberof PortfolioResponse
     */
    'amount'?: number;
    /**
     * total investment gross amount
     * @type {number}
     * @memberof PortfolioResponse
     */
    'investmentsGrossAmount'?: number;
    /**
     * total disinvestments gross amount
     * @type {number}
     * @memberof PortfolioResponse
     */
    'disinvestmentsGrossAmount'?: number;
    /**
     * total switch out gross amount
     * @type {number}
     * @memberof PortfolioResponse
     */
    'switchOutGrossAmount'?: number;
    /**
     * total switch in gross amount
     * @type {number}
     * @memberof PortfolioResponse
     */
    'switchInGrossAmount'?: number;
    /**
     * total paidAmount (investments and disinvestments)
     * @type {number}
     * @memberof PortfolioResponse
     */
    'paidAmount'?: number;
    /**
     * total FIA amount
     * @type {number}
     * @memberof PortfolioResponse
     */
    'totalFia'?: number;
    /**
     * total customer portfolio amount
     * @type {number}
     * @memberof PortfolioResponse
     */
    'totalPtf'?: number;
}
/**
 * contract position list
 * @export
 * @interface PositionData
 */
export interface PositionData {
    /**
     * contract code
     * @type {string}
     * @memberof PositionData
     */
    'contractCode'?: string;
    /**
     * position code
     * @type {string}
     * @memberof PositionData
     */
    'positionCode'?: string;
    /**
     * product code
     * @type {string}
     * @memberof PositionData
     */
    'productCode'?: string;
    /**
     * amount
     * @type {number}
     * @memberof PositionData
     */
    'amount'?: number;
    /**
     * amount date
     * @type {string}
     * @memberof PositionData
     */
    'amountDate'?: string;
    /**
     * investments gross amount
     * @type {number}
     * @memberof PositionData
     */
    'investmentsGrossAmount'?: number;
    /**
     * disinvestments gross amount
     * @type {number}
     * @memberof PositionData
     */
    'disinvestmentsGrossAmount'?: number;
    /**
     * switch out gross amount
     * @type {number}
     * @memberof PositionData
     */
    'switchOutGrossAmount'?: number;
    /**
     * switch in gross amount
     * @type {number}
     * @memberof PositionData
     */
    'switchInGrossAmount'?: number;
    /**
     * paid amount (investments and disinvestments)
     * @type {number}
     * @memberof PositionData
     */
    'paidAmount'?: number;
    /**
     * currency
     * @type {string}
     * @memberof PositionData
     */
    'currency'?: string;
    /**
     * quantity
     * @type {number}
     * @memberof PositionData
     */
    'quantity'?: number;
    /**
     * deposited amount
     * @type {number}
     * @memberof PositionData
     */
    'depositedAmount'?: number;
    /**
     * unconfirmed
     * @type {boolean}
     * @memberof PositionData
     */
    'unconfirmed'?: boolean;
    /**
     * 
     * @type {ProductData}
     * @memberof PositionData
     */
    'product'?: ProductData;
    /**
     * amount bank transfer FIA
     * @type {number}
     * @memberof PositionData
     */
    'amountBankTransferFia'?: number;
    /**
     * performance
     * @type {number}
     * @memberof PositionData
     */
    'performance'?: number;
    /**
     * performance rate
     * @type {number}
     * @memberof PositionData
     */
    'performanceRate'?: number;
    /**
     * transit items
     * @type {number}
     * @memberof PositionData
     */
    'transitItems'?: number;
    /**
     * ctv cash flows
     * @type {number}
     * @memberof PositionData
     */
    'ctvCashFlows'?: number;
    /**
     * average price
     * @type {number}
     * @memberof PositionData
     */
    'averagePrice'?: number;
    /**
     * average exchange
     * @type {number}
     * @memberof PositionData
     */
    'averageExchange'?: number;
    /**
     * market exchange
     * @type {number}
     * @memberof PositionData
     */
    'marketExchange'?: number;
    /**
     * market price
     * @type {number}
     * @memberof PositionData
     */
    'marketPrice'?: number;
    /**
     * market price currency
     * @type {string}
     * @memberof PositionData
     */
    'marketPriceCurrency'?: string;
    /**
     * price date
     * @type {string}
     * @memberof PositionData
     */
    'priceDate'?: string;
    /**
     * accrual
     * @type {number}
     * @memberof PositionData
     */
    'accrual'?: number;
    /**
     * cash amount
     * @type {number}
     * @memberof PositionData
     */
    'cashAmount'?: number;
    /**
     * cash amount date
     * @type {string}
     * @memberof PositionData
     */
    'cashAmountDate'?: string;
    /**
     * available amount
     * @type {number}
     * @memberof PositionData
     */
    'availableAmount'?: number;
    /**
     * available amount date
     * @type {string}
     * @memberof PositionData
     */
    'availableAmountDate'?: string;
    /**
     * contract position list
     * @type {Set<UnderlyingPositionData>}
     * @memberof PositionData
     */
    'underlyingPositions'?: Set<UnderlyingPositionData>;
}
/**
 * 
 * @export
 * @interface PrepareContractRegistrationRequest
 */
export interface PrepareContractRegistrationRequest {
    /**
     * registration process id
     * @type {string}
     * @memberof PrepareContractRegistrationRequest
     */
    'processId': string;
    /**
     * customer code of physical person, company or trust company
     * @type {string}
     * @memberof PrepareContractRegistrationRequest
     */
    'customerCode': string;
}
/**
 * object result
 * @export
 * @interface PrepareContractResponse
 */
export interface PrepareContractResponse {
    /**
     * registration process id
     * @type {string}
     * @memberof PrepareContractResponse
     */
    'processId'?: string;
    /**
     * document data list
     * @type {Array<DocumentData>}
     * @memberof PrepareContractResponse
     */
    'documents'?: Array<DocumentData>;
}
/**
 * product
 * @export
 * @interface ProductData
 */
export interface ProductData {
    /**
     * code
     * @type {string}
     * @memberof ProductData
     */
    'code'?: string;
    /**
     * 
     * @type {ProductTypeData}
     * @memberof ProductData
     */
    'type'?: ProductTypeData;
    /**
     * description
     * @type {string}
     * @memberof ProductData
     */
    'description'?: string;
    /**
     * currency
     * @type {string}
     * @memberof ProductData
     */
    'currency'?: string;
    /**
     * isin
     * @type {string}
     * @memberof ProductData
     */
    'isin'?: string;
    /**
     * priips
     * @type {boolean}
     * @memberof ProductData
     */
    'priips'?: boolean;
    /**
     * nav
     * @type {boolean}
     * @memberof ProductData
     */
    'nav'?: boolean;
    /**
     * 
     * @type {CompanyData}
     * @memberof ProductData
     */
    'company'?: CompanyData;
    /**
     * 
     * @type {CompanyData}
     * @memberof ProductData
     */
    'dealerCompany'?: CompanyData;
    /**
     * 
     * @type {MacroProductData}
     * @memberof ProductData
     */
    'macroProduct'?: MacroProductData;
    /**
     * 
     * @type {QuotationData}
     * @memberof ProductData
     */
    'quotation'?: QuotationData;
    /**
     * risk value
     * @type {number}
     * @memberof ProductData
     */
    'riskValue'?: number;
}
/**
 * the list of products performance 
 * @export
 * @interface ProductPerformance
 */
export interface ProductPerformance {
    /**
     * The contract number of product position
     * @type {string}
     * @memberof ProductPerformance
     */
    'contractCode'?: string;
    /**
     * The ISIN of product
     * @type {string}
     * @memberof ProductPerformance
     */
    'productIsin'?: string;
    /**
     * The product name description
     * @type {string}
     * @memberof ProductPerformance
     */
    'productDescription'?: string;
    /**
     * The product type description
     * @type {string}
     * @memberof ProductPerformance
     */
    'productType'?: string;
    /**
     * The total amount of product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'totalValue'?: number;
    /**
     * The performance value of product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'performance'?: number;
    /**
     * The invested amount of product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'totalInvested'?: number;
    /**
     * The dividends amount of product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'dividends'?: number;
    /**
     * The withdrawal amount of product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'withdrawal'?: number;
    /**
     * The average deposit amount of product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'averageDeposit'?: number;
    /**
     * The switch in amount of product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'switchIn'?: number;
    /**
     * The switch out amount product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'switchOut'?: number;
    /**
     * The plus minus value of product position
     * @type {number}
     * @memberof ProductPerformance
     */
    'plusMinus'?: number;
}
/**
 * product type
 * @export
 * @interface ProductTypeData
 */
export interface ProductTypeData {
    /**
     * code
     * @type {string}
     * @memberof ProductTypeData
     */
    'code'?: string;
    /**
     * description
     * @type {string}
     * @memberof ProductTypeData
     */
    'description'?: string;
    /**
     * sub type code
     * @type {string}
     * @memberof ProductTypeData
     */
    'subTypeCode'?: string;
    /**
     * flag quote
     * @type {boolean}
     * @memberof ProductTypeData
     */
    'flagQuote'?: boolean;
    /**
     * description
     * @type {string}
     * @memberof ProductTypeData
     */
    'familyCode'?: string;
    /**
     * description
     * @type {string}
     * @memberof ProductTypeData
     */
    'macroCategoryCode'?: string;
}
/**
 * quotation
 * @export
 * @interface QuotationData
 */
export interface QuotationData {
    /**
     * date
     * @type {string}
     * @memberof QuotationData
     */
    'date'?: string;
    /**
     * value
     * @type {number}
     * @memberof QuotationData
     */
    'value'?: number;
    /**
     * rectified value
     * @type {number}
     * @memberof QuotationData
     */
    'rectifiedValue'?: number;
    /**
     * product code
     * @type {string}
     * @memberof QuotationData
     */
    'productCode'?: string;
    /**
     * currency
     * @type {string}
     * @memberof QuotationData
     */
    'currency'?: string;
    /**
     * type
     * @type {string}
     * @memberof QuotationData
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface RegistrationAccessoryUserRequest
 */
export interface RegistrationAccessoryUserRequest {
    /**
     * registration process id
     * @type {string}
     * @memberof RegistrationAccessoryUserRequest
     */
    'processId': string;
    /**
     * customer code of physical person, company or trust company
     * @type {string}
     * @memberof RegistrationAccessoryUserRequest
     */
    'customerCode': string;
    /**
     * accessory user fiscalCode
     * @type {string}
     * @memberof RegistrationAccessoryUserRequest
     */
    'fiscalCode': string;
}
/**
 * object result
 * @export
 * @interface RegistrationAccessoryUserResponse
 */
export interface RegistrationAccessoryUserResponse {
    /**
     * registration process id
     * @type {string}
     * @memberof RegistrationAccessoryUserResponse
     */
    'processId'?: string;
    /**
     * customer code
     * @type {string}
     * @memberof RegistrationAccessoryUserResponse
     */
    'customerCode'?: string;
    /**
     * customer nominative
     * @type {string}
     * @memberof RegistrationAccessoryUserResponse
     */
    'nominative'?: string;
}
/**
 * object result
 * @export
 * @interface RegistrationBaseResponse
 */
export interface RegistrationBaseResponse {
    /**
     * registration process id
     * @type {string}
     * @memberof RegistrationBaseResponse
     */
    'processId'?: string;
}
/**
 * 
 * @export
 * @interface RegistrationFirstStepRequest
 */
export interface RegistrationFirstStepRequest {
    /**
     * subject type: PF for physical person, PG for company or trust company
     * @type {string}
     * @memberof RegistrationFirstStepRequest
     */
    'subjectType': string;
    /**
     * customer code
     * @type {string}
     * @memberof RegistrationFirstStepRequest
     */
    'customerCode': string;
    /**
     * tax code, fiscal code for physical person or vat number for company
     * @type {string}
     * @memberof RegistrationFirstStepRequest
     */
    'taxCode': string;
}
/**
 * object result
 * @export
 * @interface RegistrationFirstStepResponse
 */
export interface RegistrationFirstStepResponse {
    /**
     * registration process id
     * @type {string}
     * @memberof RegistrationFirstStepResponse
     */
    'processId'?: string;
    /**
     * customer code
     * @type {string}
     * @memberof RegistrationFirstStepResponse
     */
    'customerCode'?: string;
    /**
     * customer nominative
     * @type {string}
     * @memberof RegistrationFirstStepResponse
     */
    'nominative'?: string;
}
/**
 * object result
 * @export
 * @interface RegistrationPhoneResponse
 */
export interface RegistrationPhoneResponse {
    /**
     * verified phone number
     * @type {string}
     * @memberof RegistrationPhoneResponse
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * response code
     * @type {string}
     * @memberof Response
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof Response
     */
    'message'?: string;
    /**
     * object result
     * @type {object}
     * @memberof Response
     */
    'result'?: object;
}
/**
 * 
 * @export
 * @interface ResponseAgentDataResponse
 */
export interface ResponseAgentDataResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponseAgentDataResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseAgentDataResponse
     */
    'message'?: string;
    /**
     * 
     * @type {AgentDataResponse}
     * @memberof ResponseAgentDataResponse
     */
    'result'?: AgentDataResponse;
}
/**
 * 
 * @export
 * @interface ResponseChangeContactResponse
 */
export interface ResponseChangeContactResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponseChangeContactResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseChangeContactResponse
     */
    'message'?: string;
    /**
     * 
     * @type {ChangeContactResponse}
     * @memberof ResponseChangeContactResponse
     */
    'result'?: ChangeContactResponse;
}
/**
 * 
 * @export
 * @interface ResponseComposition
 */
export interface ResponseComposition {
    /**
     * response code
     * @type {string}
     * @memberof ResponseComposition
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseComposition
     */
    'message'?: string;
    /**
     * 
     * @type {Composition}
     * @memberof ResponseComposition
     */
    'result'?: Composition;
}
/**
 * 
 * @export
 * @interface ResponseInfoServiceBean
 */
export interface ResponseInfoServiceBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseInfoServiceBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseInfoServiceBean
     */
    'message'?: string;
    /**
     * 
     * @type {InfoServiceBean}
     * @memberof ResponseInfoServiceBean
     */
    'result'?: InfoServiceBean;
}
/**
 * 
 * @export
 * @interface ResponseListLinkedSubject
 */
export interface ResponseListLinkedSubject {
    /**
     * response code
     * @type {string}
     * @memberof ResponseListLinkedSubject
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseListLinkedSubject
     */
    'message'?: string;
    /**
     * object result
     * @type {Array<LinkedSubject>}
     * @memberof ResponseListLinkedSubject
     */
    'result'?: Array<LinkedSubject>;
}
/**
 * 
 * @export
 * @interface ResponseListPirDepositDetailBean
 */
export interface ResponseListPirDepositDetailBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseListPirDepositDetailBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseListPirDepositDetailBean
     */
    'message'?: string;
    /**
     * object result
     * @type {Array<PirDepositDetailBean>}
     * @memberof ResponseListPirDepositDetailBean
     */
    'result'?: Array<PirDepositDetailBean>;
}
/**
 * 
 * @export
 * @interface ResponseMapStringListMovementData
 */
export interface ResponseMapStringListMovementData {
    /**
     * response code
     * @type {string}
     * @memberof ResponseMapStringListMovementData
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseMapStringListMovementData
     */
    'message'?: string;
    /**
     * object result
     * @type {{ [key: string]: Array<MovementData>; }}
     * @memberof ResponseMapStringListMovementData
     */
    'result'?: { [key: string]: Array<MovementData>; };
}
/**
 * 
 * @export
 * @interface ResponseMapStringPirPositionBean
 */
export interface ResponseMapStringPirPositionBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseMapStringPirPositionBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseMapStringPirPositionBean
     */
    'message'?: string;
    /**
     * object result
     * @type {{ [key: string]: PirPositionBean; }}
     * @memberof ResponseMapStringPirPositionBean
     */
    'result'?: { [key: string]: PirPositionBean; };
}
/**
 * 
 * @export
 * @interface ResponseMonitoringResult
 */
export interface ResponseMonitoringResult {
    /**
     * response code
     * @type {string}
     * @memberof ResponseMonitoringResult
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseMonitoringResult
     */
    'message'?: string;
    /**
     * 
     * @type {MonitoringResult}
     * @memberof ResponseMonitoringResult
     */
    'result'?: MonitoringResult;
}
/**
 * 
 * @export
 * @interface ResponsePermissionServiceBean
 */
export interface ResponsePermissionServiceBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePermissionServiceBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePermissionServiceBean
     */
    'message'?: string;
    /**
     * 
     * @type {PermissionServiceBean}
     * @memberof ResponsePermissionServiceBean
     */
    'result'?: PermissionServiceBean;
}
/**
 * 
 * @export
 * @interface ResponsePersonalDataResponse
 */
export interface ResponsePersonalDataResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePersonalDataResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePersonalDataResponse
     */
    'message'?: string;
    /**
     * 
     * @type {PersonalDataResponse}
     * @memberof ResponsePersonalDataResponse
     */
    'result'?: PersonalDataResponse;
}
/**
 * 
 * @export
 * @interface ResponsePortfolioPerformanceResponse
 */
export interface ResponsePortfolioPerformanceResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePortfolioPerformanceResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePortfolioPerformanceResponse
     */
    'message'?: string;
    /**
     * 
     * @type {PortfolioPerformanceResponse}
     * @memberof ResponsePortfolioPerformanceResponse
     */
    'result'?: PortfolioPerformanceResponse;
}
/**
 * 
 * @export
 * @interface ResponsePortfolioResponse
 */
export interface ResponsePortfolioResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePortfolioResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePortfolioResponse
     */
    'message'?: string;
    /**
     * 
     * @type {PortfolioResponse}
     * @memberof ResponsePortfolioResponse
     */
    'result'?: PortfolioResponse;
}
/**
 * 
 * @export
 * @interface ResponsePrepareContractResponse
 */
export interface ResponsePrepareContractResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePrepareContractResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePrepareContractResponse
     */
    'message'?: string;
    /**
     * 
     * @type {PrepareContractResponse}
     * @memberof ResponsePrepareContractResponse
     */
    'result'?: PrepareContractResponse;
}
/**
 * 
 * @export
 * @interface ResponseRegistrationAccessoryUserResponse
 */
export interface ResponseRegistrationAccessoryUserResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponseRegistrationAccessoryUserResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseRegistrationAccessoryUserResponse
     */
    'message'?: string;
    /**
     * 
     * @type {RegistrationAccessoryUserResponse}
     * @memberof ResponseRegistrationAccessoryUserResponse
     */
    'result'?: RegistrationAccessoryUserResponse;
}
/**
 * 
 * @export
 * @interface ResponseRegistrationBaseResponse
 */
export interface ResponseRegistrationBaseResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponseRegistrationBaseResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseRegistrationBaseResponse
     */
    'message'?: string;
    /**
     * 
     * @type {RegistrationBaseResponse}
     * @memberof ResponseRegistrationBaseResponse
     */
    'result'?: RegistrationBaseResponse;
}
/**
 * 
 * @export
 * @interface ResponseRegistrationFirstStepResponse
 */
export interface ResponseRegistrationFirstStepResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponseRegistrationFirstStepResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseRegistrationFirstStepResponse
     */
    'message'?: string;
    /**
     * 
     * @type {RegistrationFirstStepResponse}
     * @memberof ResponseRegistrationFirstStepResponse
     */
    'result'?: RegistrationFirstStepResponse;
}
/**
 * 
 * @export
 * @interface ResponseRegistrationPhoneResponse
 */
export interface ResponseRegistrationPhoneResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponseRegistrationPhoneResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseRegistrationPhoneResponse
     */
    'message'?: string;
    /**
     * 
     * @type {RegistrationPhoneResponse}
     * @memberof ResponseRegistrationPhoneResponse
     */
    'result'?: RegistrationPhoneResponse;
}
/**
 * 
 * @export
 * @interface ResponseTrustAccountsResponse
 */
export interface ResponseTrustAccountsResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponseTrustAccountsResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseTrustAccountsResponse
     */
    'message'?: string;
    /**
     * 
     * @type {TrustAccountsResponse}
     * @memberof ResponseTrustAccountsResponse
     */
    'result'?: TrustAccountsResponse;
}
/**
 * 
 * @export
 * @interface ResponseYearlyPirIndicatorsBean
 */
export interface ResponseYearlyPirIndicatorsBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseYearlyPirIndicatorsBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseYearlyPirIndicatorsBean
     */
    'message'?: string;
    /**
     * 
     * @type {YearlyPirIndicatorsBean}
     * @memberof ResponseYearlyPirIndicatorsBean
     */
    'result'?: YearlyPirIndicatorsBean;
}
/**
 * Trust company account list
 * @export
 * @interface TrustAccountData
 */
export interface TrustAccountData {
    /**
     * Account code
     * @type {string}
     * @memberof TrustAccountData
     */
    'accountCode'?: string;
    /**
     * Account nominaitve
     * @type {string}
     * @memberof TrustAccountData
     */
    'nominative'?: string;
}
/**
 * object result
 * @export
 * @interface TrustAccountsResponse
 */
export interface TrustAccountsResponse {
    /**
     * Trust company account list
     * @type {Array<TrustAccountData>}
     * @memberof TrustAccountsResponse
     */
    'accounts'?: Array<TrustAccountData>;
}
/**
 * contract position list
 * @export
 * @interface UnderlyingPositionData
 */
export interface UnderlyingPositionData {
    /**
     * contract code
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'contractCode'?: string;
    /**
     * position code
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'positionCode'?: string;
    /**
     * product code
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'productCode'?: string;
    /**
     * amount
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'amount'?: number;
    /**
     * amount date
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'amountDate'?: string;
    /**
     * investments gross amount
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'investmentsGrossAmount'?: number;
    /**
     * disinvestments gross amount
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'disinvestmentsGrossAmount'?: number;
    /**
     * switch out gross amount
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'switchOutGrossAmount'?: number;
    /**
     * switch in gross amount
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'switchInGrossAmount'?: number;
    /**
     * paid amount (investments and disinvestments)
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'paidAmount'?: number;
    /**
     * currency
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'currency'?: string;
    /**
     * quantity
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'quantity'?: number;
    /**
     * deposited amount
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'depositedAmount'?: number;
    /**
     * unconfirmed
     * @type {boolean}
     * @memberof UnderlyingPositionData
     */
    'unconfirmed'?: boolean;
    /**
     * 
     * @type {ProductData}
     * @memberof UnderlyingPositionData
     */
    'product'?: ProductData;
    /**
     * amount bank transfer FIA
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'amountBankTransferFia'?: number;
    /**
     * performance
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'performance'?: number;
    /**
     * performance rate
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'performanceRate'?: number;
    /**
     * transit items
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'transitItems'?: number;
    /**
     * ctv cash flows
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'ctvCashFlows'?: number;
    /**
     * average price
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'averagePrice'?: number;
    /**
     * average exchange
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'averageExchange'?: number;
    /**
     * market exchange
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'marketExchange'?: number;
    /**
     * market price
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'marketPrice'?: number;
    /**
     * market price currency
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'marketPriceCurrency'?: string;
    /**
     * price date
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'priceDate'?: string;
    /**
     * accrual
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'accrual'?: number;
    /**
     * cash amount
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'cashAmount'?: number;
    /**
     * cash amount date
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'cashAmountDate'?: string;
    /**
     * available amount
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'availableAmount'?: number;
    /**
     * available amount date
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'availableAmountDate'?: string;
    /**
     * underlying weight percentage
     * @type {number}
     * @memberof UnderlyingPositionData
     */
    'percentage'?: number;
    /**
     * component type code
     * @type {string}
     * @memberof UnderlyingPositionData
     */
    'componentTypeCode'?: string;
}
/**
 * object result
 * @export
 * @interface YearlyPirIndicatorsBean
 */
export interface YearlyPirIndicatorsBean {
    /**
     * PIR code
     * @type {string}
     * @memberof YearlyPirIndicatorsBean
     */
    'pirCode'?: string;
    /**
     * Pir year indicator info in format map<string,PirIndicatorBean>, field subtype: \'application/json\'
     * @type {{ [key: string]: PirIndicatorBean; }}
     * @memberof YearlyPirIndicatorsBean
     */
    'indicatorMap'?: { [key: string]: PirIndicatorBean; };
}

/**
 * ContactProviderApi - axios parameter creator
 * @export
 */
export const ContactProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate contact
         * @param {ChangeContactRequest} [changeContactRequest] Activate contact request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateContact1: async (changeContactRequest?: ChangeContactRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contact/activateContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeContactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify contact info
         * @param {ContactRequest} [contactRequest] Contact information request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkContact1: async (contactRequest?: ContactRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contact/checkContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate change contact data
         * @param {ChangeContactRequest} [changeContactRequest] Prepare change user contact request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareChangeContact1: async (changeContactRequest?: ChangeContactRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contact/prepareChangeContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeContactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactProviderApi - functional programming interface
 * @export
 */
export const ContactProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate contact
         * @param {ChangeContactRequest} [changeContactRequest] Activate contact request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateContact1(changeContactRequest?: ChangeContactRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateContact1(changeContactRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify contact info
         * @param {ContactRequest} [contactRequest] Contact information request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkContact1(contactRequest?: ContactRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkContact1(contactRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate change contact data
         * @param {ChangeContactRequest} [changeContactRequest] Prepare change user contact request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareChangeContact1(changeContactRequest?: ChangeContactRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChangeContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepareChangeContact1(changeContactRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactProviderApi - factory interface
 * @export
 */
export const ContactProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate contact
         * @param {ChangeContactRequest} [changeContactRequest] Activate contact request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateContact1(changeContactRequest?: ChangeContactRequest, options?: any): AxiosPromise<Response> {
            return localVarFp.activateContact1(changeContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify contact info
         * @param {ContactRequest} [contactRequest] Contact information request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkContact1(contactRequest?: ContactRequest, options?: any): AxiosPromise<Response> {
            return localVarFp.checkContact1(contactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate change contact data
         * @param {ChangeContactRequest} [changeContactRequest] Prepare change user contact request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareChangeContact1(changeContactRequest?: ChangeContactRequest, options?: any): AxiosPromise<ResponseChangeContactResponse> {
            return localVarFp.prepareChangeContact1(changeContactRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateContact1 operation in ContactProviderApi.
 * @export
 * @interface ContactProviderApiActivateContact1Request
 */
export interface ContactProviderApiActivateContact1Request {
    /**
     * Activate contact request
     * @type {ChangeContactRequest}
     * @memberof ContactProviderApiActivateContact1
     */
    readonly changeContactRequest?: ChangeContactRequest
}

/**
 * Request parameters for checkContact1 operation in ContactProviderApi.
 * @export
 * @interface ContactProviderApiCheckContact1Request
 */
export interface ContactProviderApiCheckContact1Request {
    /**
     * Contact information request
     * @type {ContactRequest}
     * @memberof ContactProviderApiCheckContact1
     */
    readonly contactRequest?: ContactRequest
}

/**
 * Request parameters for prepareChangeContact1 operation in ContactProviderApi.
 * @export
 * @interface ContactProviderApiPrepareChangeContact1Request
 */
export interface ContactProviderApiPrepareChangeContact1Request {
    /**
     * Prepare change user contact request
     * @type {ChangeContactRequest}
     * @memberof ContactProviderApiPrepareChangeContact1
     */
    readonly changeContactRequest?: ChangeContactRequest
}

/**
 * ContactProviderApi - object-oriented interface
 * @export
 * @class ContactProviderApi
 * @extends {BaseAPI}
 */
export class ContactProviderApi extends BaseAPI {
    /**
     * 
     * @summary Activate contact
     * @param {ContactProviderApiActivateContact1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactProviderApi
     */
    public activateContact1(requestParameters: ContactProviderApiActivateContact1Request = {}, options?: AxiosRequestConfig) {
        return ContactProviderApiFp(this.configuration).activateContact1(requestParameters.changeContactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify contact info
     * @param {ContactProviderApiCheckContact1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactProviderApi
     */
    public checkContact1(requestParameters: ContactProviderApiCheckContact1Request = {}, options?: AxiosRequestConfig) {
        return ContactProviderApiFp(this.configuration).checkContact1(requestParameters.contactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate change contact data
     * @param {ContactProviderApiPrepareChangeContact1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactProviderApi
     */
    public prepareChangeContact1(requestParameters: ContactProviderApiPrepareChangeContact1Request = {}, options?: AxiosRequestConfig) {
        return ContactProviderApiFp(this.configuration).prepareChangeContact1(requestParameters.changeContactRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerProviderApi - axios parameter creator
 * @export
 */
export const CustomerProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve user personal data
         * @param {string} customerCode Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLinkedSubjectsByCustomer1: async (customerCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('retrieveLinkedSubjectsByCustomer1', 'customerCode', customerCode)
            const localVarPath = `/customer/linkedSubjects/{customerCode}`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve account list for the trust Company
         * @param {string} [customerCode] Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTrustAccounts1: async (customerCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/trust/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerCode !== undefined) {
                localVarQueryParameter['customerCode'] = customerCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerProviderApi - functional programming interface
 * @export
 */
export const CustomerProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve user personal data
         * @param {string} customerCode Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveLinkedSubjectsByCustomer1(customerCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListLinkedSubject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveLinkedSubjectsByCustomer1(customerCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve account list for the trust Company
         * @param {string} [customerCode] Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTrustAccounts1(customerCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTrustAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTrustAccounts1(customerCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerProviderApi - factory interface
 * @export
 */
export const CustomerProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve user personal data
         * @param {string} customerCode Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLinkedSubjectsByCustomer1(customerCode: string, options?: any): AxiosPromise<ResponseListLinkedSubject> {
            return localVarFp.retrieveLinkedSubjectsByCustomer1(customerCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve account list for the trust Company
         * @param {string} [customerCode] Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTrustAccounts1(customerCode?: string, options?: any): AxiosPromise<ResponseTrustAccountsResponse> {
            return localVarFp.retrieveTrustAccounts1(customerCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for retrieveLinkedSubjectsByCustomer1 operation in CustomerProviderApi.
 * @export
 * @interface CustomerProviderApiRetrieveLinkedSubjectsByCustomer1Request
 */
export interface CustomerProviderApiRetrieveLinkedSubjectsByCustomer1Request {
    /**
     * Customer code
     * @type {string}
     * @memberof CustomerProviderApiRetrieveLinkedSubjectsByCustomer1
     */
    readonly customerCode: string
}

/**
 * Request parameters for retrieveTrustAccounts1 operation in CustomerProviderApi.
 * @export
 * @interface CustomerProviderApiRetrieveTrustAccounts1Request
 */
export interface CustomerProviderApiRetrieveTrustAccounts1Request {
    /**
     * Customer code
     * @type {string}
     * @memberof CustomerProviderApiRetrieveTrustAccounts1
     */
    readonly customerCode?: string
}

/**
 * CustomerProviderApi - object-oriented interface
 * @export
 * @class CustomerProviderApi
 * @extends {BaseAPI}
 */
export class CustomerProviderApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve user personal data
     * @param {CustomerProviderApiRetrieveLinkedSubjectsByCustomer1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerProviderApi
     */
    public retrieveLinkedSubjectsByCustomer1(requestParameters: CustomerProviderApiRetrieveLinkedSubjectsByCustomer1Request, options?: AxiosRequestConfig) {
        return CustomerProviderApiFp(this.configuration).retrieveLinkedSubjectsByCustomer1(requestParameters.customerCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve account list for the trust Company
     * @param {CustomerProviderApiRetrieveTrustAccounts1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerProviderApi
     */
    public retrieveTrustAccounts1(requestParameters: CustomerProviderApiRetrieveTrustAccounts1Request = {}, options?: AxiosRequestConfig) {
        return CustomerProviderApiFp(this.configuration).retrieveTrustAccounts1(requestParameters.customerCode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InfoProviderApi - axios parameter creator
 * @export
 */
export const InfoProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoProviderApi - functional programming interface
 * @export
 */
export const InfoProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async info1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseInfoServiceBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.info1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InfoProviderApi - factory interface
 * @export
 */
export const InfoProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoProviderApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info1(options?: any): AxiosPromise<ResponseInfoServiceBean> {
            return localVarFp.info1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoProviderApi - object-oriented interface
 * @export
 * @class InfoProviderApi
 * @extends {BaseAPI}
 */
export class InfoProviderApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoProviderApi
     */
    public info1(options?: AxiosRequestConfig) {
        return InfoProviderApiFp(this.configuration).info1(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PirBoxProviderApi - axios parameter creator
 * @export
 */
export const PirBoxProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve PIR plan positions details
         * @param {string} customerCode Customer code
         * @param {string} pirCode PIR code
         * @param {boolean} [includeClosedPositions] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePirDepositDetailPositions1: async (customerCode: string, pirCode: string, includeClosedPositions?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('retrievePirDepositDetailPositions1', 'customerCode', customerCode)
            // verify required parameter 'pirCode' is not null or undefined
            assertParamExists('retrievePirDepositDetailPositions1', 'pirCode', pirCode)
            const localVarPath = `/pir/{pirCode}/{customerCode}/positions`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)))
                .replace(`{${"pirCode"}}`, encodeURIComponent(String(pirCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeClosedPositions !== undefined) {
                localVarQueryParameter['includeClosedPositions'] = includeClosedPositions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve PIR plan detail
         * @param {string} customerCode Customer code
         * @param {boolean} [includeClosedPositions] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePirDepositPlan1: async (customerCode: string, includeClosedPositions?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('retrievePirDepositPlan1', 'customerCode', customerCode)
            const localVarPath = `/pir/plan/{customerCode}`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeClosedPositions !== undefined) {
                localVarQueryParameter['includeClosedPositions'] = includeClosedPositions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve yearly PIR indicator
         * @param {string} customerCode Customer code
         * @param {string} pirCode PIR code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveYearlyPirIndicatorDepositDetail1: async (customerCode: string, pirCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('retrieveYearlyPirIndicatorDepositDetail1', 'customerCode', customerCode)
            // verify required parameter 'pirCode' is not null or undefined
            assertParamExists('retrieveYearlyPirIndicatorDepositDetail1', 'pirCode', pirCode)
            const localVarPath = `/pir/{pirCode}/{customerCode}/position/indicator`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)))
                .replace(`{${"pirCode"}}`, encodeURIComponent(String(pirCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PirBoxProviderApi - functional programming interface
 * @export
 */
export const PirBoxProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PirBoxProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve PIR plan positions details
         * @param {string} customerCode Customer code
         * @param {string} pirCode PIR code
         * @param {boolean} [includeClosedPositions] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePirDepositDetailPositions1(customerCode: string, pirCode: string, includeClosedPositions?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMapStringPirPositionBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePirDepositDetailPositions1(customerCode, pirCode, includeClosedPositions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve PIR plan detail
         * @param {string} customerCode Customer code
         * @param {boolean} [includeClosedPositions] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePirDepositPlan1(customerCode: string, includeClosedPositions?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListPirDepositDetailBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePirDepositPlan1(customerCode, includeClosedPositions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve yearly PIR indicator
         * @param {string} customerCode Customer code
         * @param {string} pirCode PIR code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveYearlyPirIndicatorDepositDetail1(customerCode: string, pirCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseYearlyPirIndicatorsBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveYearlyPirIndicatorDepositDetail1(customerCode, pirCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PirBoxProviderApi - factory interface
 * @export
 */
export const PirBoxProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PirBoxProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve PIR plan positions details
         * @param {string} customerCode Customer code
         * @param {string} pirCode PIR code
         * @param {boolean} [includeClosedPositions] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePirDepositDetailPositions1(customerCode: string, pirCode: string, includeClosedPositions?: boolean, options?: any): AxiosPromise<ResponseMapStringPirPositionBean> {
            return localVarFp.retrievePirDepositDetailPositions1(customerCode, pirCode, includeClosedPositions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve PIR plan detail
         * @param {string} customerCode Customer code
         * @param {boolean} [includeClosedPositions] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePirDepositPlan1(customerCode: string, includeClosedPositions?: boolean, options?: any): AxiosPromise<ResponseListPirDepositDetailBean> {
            return localVarFp.retrievePirDepositPlan1(customerCode, includeClosedPositions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve yearly PIR indicator
         * @param {string} customerCode Customer code
         * @param {string} pirCode PIR code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveYearlyPirIndicatorDepositDetail1(customerCode: string, pirCode: string, options?: any): AxiosPromise<ResponseYearlyPirIndicatorsBean> {
            return localVarFp.retrieveYearlyPirIndicatorDepositDetail1(customerCode, pirCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for retrievePirDepositDetailPositions1 operation in PirBoxProviderApi.
 * @export
 * @interface PirBoxProviderApiRetrievePirDepositDetailPositions1Request
 */
export interface PirBoxProviderApiRetrievePirDepositDetailPositions1Request {
    /**
     * Customer code
     * @type {string}
     * @memberof PirBoxProviderApiRetrievePirDepositDetailPositions1
     */
    readonly customerCode: string

    /**
     * PIR code
     * @type {string}
     * @memberof PirBoxProviderApiRetrievePirDepositDetailPositions1
     */
    readonly pirCode: string

    /**
     * Include closed positions
     * @type {boolean}
     * @memberof PirBoxProviderApiRetrievePirDepositDetailPositions1
     */
    readonly includeClosedPositions?: boolean
}

/**
 * Request parameters for retrievePirDepositPlan1 operation in PirBoxProviderApi.
 * @export
 * @interface PirBoxProviderApiRetrievePirDepositPlan1Request
 */
export interface PirBoxProviderApiRetrievePirDepositPlan1Request {
    /**
     * Customer code
     * @type {string}
     * @memberof PirBoxProviderApiRetrievePirDepositPlan1
     */
    readonly customerCode: string

    /**
     * Include closed positions
     * @type {boolean}
     * @memberof PirBoxProviderApiRetrievePirDepositPlan1
     */
    readonly includeClosedPositions?: boolean
}

/**
 * Request parameters for retrieveYearlyPirIndicatorDepositDetail1 operation in PirBoxProviderApi.
 * @export
 * @interface PirBoxProviderApiRetrieveYearlyPirIndicatorDepositDetail1Request
 */
export interface PirBoxProviderApiRetrieveYearlyPirIndicatorDepositDetail1Request {
    /**
     * Customer code
     * @type {string}
     * @memberof PirBoxProviderApiRetrieveYearlyPirIndicatorDepositDetail1
     */
    readonly customerCode: string

    /**
     * PIR code
     * @type {string}
     * @memberof PirBoxProviderApiRetrieveYearlyPirIndicatorDepositDetail1
     */
    readonly pirCode: string
}

/**
 * PirBoxProviderApi - object-oriented interface
 * @export
 * @class PirBoxProviderApi
 * @extends {BaseAPI}
 */
export class PirBoxProviderApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve PIR plan positions details
     * @param {PirBoxProviderApiRetrievePirDepositDetailPositions1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PirBoxProviderApi
     */
    public retrievePirDepositDetailPositions1(requestParameters: PirBoxProviderApiRetrievePirDepositDetailPositions1Request, options?: AxiosRequestConfig) {
        return PirBoxProviderApiFp(this.configuration).retrievePirDepositDetailPositions1(requestParameters.customerCode, requestParameters.pirCode, requestParameters.includeClosedPositions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve PIR plan detail
     * @param {PirBoxProviderApiRetrievePirDepositPlan1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PirBoxProviderApi
     */
    public retrievePirDepositPlan1(requestParameters: PirBoxProviderApiRetrievePirDepositPlan1Request, options?: AxiosRequestConfig) {
        return PirBoxProviderApiFp(this.configuration).retrievePirDepositPlan1(requestParameters.customerCode, requestParameters.includeClosedPositions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve yearly PIR indicator
     * @param {PirBoxProviderApiRetrieveYearlyPirIndicatorDepositDetail1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PirBoxProviderApi
     */
    public retrieveYearlyPirIndicatorDepositDetail1(requestParameters: PirBoxProviderApiRetrieveYearlyPirIndicatorDepositDetail1Request, options?: AxiosRequestConfig) {
        return PirBoxProviderApiFp(this.configuration).retrieveYearlyPirIndicatorDepositDetail1(requestParameters.customerCode, requestParameters.pirCode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PortfolioProviderApi - axios parameter creator
 * @export
 */
export const PortfolioProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Execute monitoring suitability on portfolio for monitoring with a simplified result.
         * @param {string} customerCode Customer code
         * @param {boolean} [jointHolders] Joint holder flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateMonitoring1: async (customerCode: string, jointHolders?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('evaluateMonitoring1', 'customerCode', customerCode)
            const localVarPath = `/portfolio/realEconomy/monitoring/{customerCode}`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jointHolders !== undefined) {
                localVarQueryParameter['jointHolders'] = jointHolders;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve movements according to list of position codes inside interval date specified
         * @param {MovementRequest} [movementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMovement1: async (movementRequest?: MovementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/movement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(movementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a pdf product datasheet using its product code
         * @param {string} productCode Product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePdfDataSheet1: async (productCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCode' is not null or undefined
            assertParamExists('retrievePdfDataSheet1', 'productCode', productCode)
            const localVarPath = `/portfolio/product/{productCode}/datasheet`
                .replace(`{${"productCode"}}`, encodeURIComponent(String(productCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Portfolio Performance
         * @param {PortfolioPerformanceRequest} [portfolioPerformanceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePerformance1: async (portfolioPerformanceRequest?: PortfolioPerformanceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/performance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioPerformanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Portfolio
         * @param {PortfolioRequest} [portfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePortfolio1: async (portfolioRequest?: PortfolioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/load`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve real economy positions for customer code grouped by different type (product, product type , duration ...) 
         * @param {CompositionType} compositionType Composition type
         * @param {string} customerCode Customer code
         * @param {boolean} [jointHolders] Joint holder flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRealEconomyPortfolioComposition1: async (compositionType: CompositionType, customerCode: string, jointHolders?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compositionType' is not null or undefined
            assertParamExists('retrieveRealEconomyPortfolioComposition1', 'compositionType', compositionType)
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('retrieveRealEconomyPortfolioComposition1', 'customerCode', customerCode)
            const localVarPath = `/portfolio/realEconomy/composition/{compositionType}/{customerCode}`
                .replace(`{${"compositionType"}}`, encodeURIComponent(String(compositionType)))
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jointHolders !== undefined) {
                localVarQueryParameter['jointHolders'] = jointHolders;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioProviderApi - functional programming interface
 * @export
 */
export const PortfolioProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Execute monitoring suitability on portfolio for monitoring with a simplified result.
         * @param {string} customerCode Customer code
         * @param {boolean} [jointHolders] Joint holder flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateMonitoring1(customerCode: string, jointHolders?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMonitoringResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateMonitoring1(customerCode, jointHolders, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve movements according to list of position codes inside interval date specified
         * @param {MovementRequest} [movementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveMovement1(movementRequest?: MovementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMapStringListMovementData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveMovement1(movementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a pdf product datasheet using its product code
         * @param {string} productCode Product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePdfDataSheet1(productCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePdfDataSheet1(productCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve Portfolio Performance
         * @param {PortfolioPerformanceRequest} [portfolioPerformanceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePerformance1(portfolioPerformanceRequest?: PortfolioPerformanceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortfolioPerformanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePerformance1(portfolioPerformanceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve Portfolio
         * @param {PortfolioRequest} [portfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePortfolio1(portfolioRequest?: PortfolioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortfolioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePortfolio1(portfolioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve real economy positions for customer code grouped by different type (product, product type , duration ...) 
         * @param {CompositionType} compositionType Composition type
         * @param {string} customerCode Customer code
         * @param {boolean} [jointHolders] Joint holder flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRealEconomyPortfolioComposition1(compositionType: CompositionType, customerCode: string, jointHolders?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseComposition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRealEconomyPortfolioComposition1(compositionType, customerCode, jointHolders, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortfolioProviderApi - factory interface
 * @export
 */
export const PortfolioProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary Execute monitoring suitability on portfolio for monitoring with a simplified result.
         * @param {string} customerCode Customer code
         * @param {boolean} [jointHolders] Joint holder flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateMonitoring1(customerCode: string, jointHolders?: boolean, options?: any): AxiosPromise<ResponseMonitoringResult> {
            return localVarFp.evaluateMonitoring1(customerCode, jointHolders, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve movements according to list of position codes inside interval date specified
         * @param {MovementRequest} [movementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMovement1(movementRequest?: MovementRequest, options?: any): AxiosPromise<ResponseMapStringListMovementData> {
            return localVarFp.retrieveMovement1(movementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a pdf product datasheet using its product code
         * @param {string} productCode Product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePdfDataSheet1(productCode: string, options?: any): AxiosPromise<void> {
            return localVarFp.retrievePdfDataSheet1(productCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Portfolio Performance
         * @param {PortfolioPerformanceRequest} [portfolioPerformanceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePerformance1(portfolioPerformanceRequest?: PortfolioPerformanceRequest, options?: any): AxiosPromise<ResponsePortfolioPerformanceResponse> {
            return localVarFp.retrievePerformance1(portfolioPerformanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Portfolio
         * @param {PortfolioRequest} [portfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePortfolio1(portfolioRequest?: PortfolioRequest, options?: any): AxiosPromise<ResponsePortfolioResponse> {
            return localVarFp.retrievePortfolio1(portfolioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve real economy positions for customer code grouped by different type (product, product type , duration ...) 
         * @param {CompositionType} compositionType Composition type
         * @param {string} customerCode Customer code
         * @param {boolean} [jointHolders] Joint holder flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRealEconomyPortfolioComposition1(compositionType: CompositionType, customerCode: string, jointHolders?: boolean, options?: any): AxiosPromise<ResponseComposition> {
            return localVarFp.retrieveRealEconomyPortfolioComposition1(compositionType, customerCode, jointHolders, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for evaluateMonitoring1 operation in PortfolioProviderApi.
 * @export
 * @interface PortfolioProviderApiEvaluateMonitoring1Request
 */
export interface PortfolioProviderApiEvaluateMonitoring1Request {
    /**
     * Customer code
     * @type {string}
     * @memberof PortfolioProviderApiEvaluateMonitoring1
     */
    readonly customerCode: string

    /**
     * Joint holder flag
     * @type {boolean}
     * @memberof PortfolioProviderApiEvaluateMonitoring1
     */
    readonly jointHolders?: boolean
}

/**
 * Request parameters for retrieveMovement1 operation in PortfolioProviderApi.
 * @export
 * @interface PortfolioProviderApiRetrieveMovement1Request
 */
export interface PortfolioProviderApiRetrieveMovement1Request {
    /**
     * 
     * @type {MovementRequest}
     * @memberof PortfolioProviderApiRetrieveMovement1
     */
    readonly movementRequest?: MovementRequest
}

/**
 * Request parameters for retrievePdfDataSheet1 operation in PortfolioProviderApi.
 * @export
 * @interface PortfolioProviderApiRetrievePdfDataSheet1Request
 */
export interface PortfolioProviderApiRetrievePdfDataSheet1Request {
    /**
     * Product code
     * @type {string}
     * @memberof PortfolioProviderApiRetrievePdfDataSheet1
     */
    readonly productCode: string
}

/**
 * Request parameters for retrievePerformance1 operation in PortfolioProviderApi.
 * @export
 * @interface PortfolioProviderApiRetrievePerformance1Request
 */
export interface PortfolioProviderApiRetrievePerformance1Request {
    /**
     * 
     * @type {PortfolioPerformanceRequest}
     * @memberof PortfolioProviderApiRetrievePerformance1
     */
    readonly portfolioPerformanceRequest?: PortfolioPerformanceRequest
}

/**
 * Request parameters for retrievePortfolio1 operation in PortfolioProviderApi.
 * @export
 * @interface PortfolioProviderApiRetrievePortfolio1Request
 */
export interface PortfolioProviderApiRetrievePortfolio1Request {
    /**
     * 
     * @type {PortfolioRequest}
     * @memberof PortfolioProviderApiRetrievePortfolio1
     */
    readonly portfolioRequest?: PortfolioRequest
}

/**
 * Request parameters for retrieveRealEconomyPortfolioComposition1 operation in PortfolioProviderApi.
 * @export
 * @interface PortfolioProviderApiRetrieveRealEconomyPortfolioComposition1Request
 */
export interface PortfolioProviderApiRetrieveRealEconomyPortfolioComposition1Request {
    /**
     * Composition type
     * @type {CompositionType}
     * @memberof PortfolioProviderApiRetrieveRealEconomyPortfolioComposition1
     */
    readonly compositionType: CompositionType

    /**
     * Customer code
     * @type {string}
     * @memberof PortfolioProviderApiRetrieveRealEconomyPortfolioComposition1
     */
    readonly customerCode: string

    /**
     * Joint holder flag
     * @type {boolean}
     * @memberof PortfolioProviderApiRetrieveRealEconomyPortfolioComposition1
     */
    readonly jointHolders?: boolean
}

/**
 * PortfolioProviderApi - object-oriented interface
 * @export
 * @class PortfolioProviderApi
 * @extends {BaseAPI}
 */
export class PortfolioProviderApi extends BaseAPI {
    /**
     * 
     * @summary Execute monitoring suitability on portfolio for monitoring with a simplified result.
     * @param {PortfolioProviderApiEvaluateMonitoring1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProviderApi
     */
    public evaluateMonitoring1(requestParameters: PortfolioProviderApiEvaluateMonitoring1Request, options?: AxiosRequestConfig) {
        return PortfolioProviderApiFp(this.configuration).evaluateMonitoring1(requestParameters.customerCode, requestParameters.jointHolders, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve movements according to list of position codes inside interval date specified
     * @param {PortfolioProviderApiRetrieveMovement1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProviderApi
     */
    public retrieveMovement1(requestParameters: PortfolioProviderApiRetrieveMovement1Request = {}, options?: AxiosRequestConfig) {
        return PortfolioProviderApiFp(this.configuration).retrieveMovement1(requestParameters.movementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a pdf product datasheet using its product code
     * @param {PortfolioProviderApiRetrievePdfDataSheet1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProviderApi
     */
    public retrievePdfDataSheet1(requestParameters: PortfolioProviderApiRetrievePdfDataSheet1Request, options?: AxiosRequestConfig) {
        return PortfolioProviderApiFp(this.configuration).retrievePdfDataSheet1(requestParameters.productCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Portfolio Performance
     * @param {PortfolioProviderApiRetrievePerformance1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProviderApi
     */
    public retrievePerformance1(requestParameters: PortfolioProviderApiRetrievePerformance1Request = {}, options?: AxiosRequestConfig) {
        return PortfolioProviderApiFp(this.configuration).retrievePerformance1(requestParameters.portfolioPerformanceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Portfolio
     * @param {PortfolioProviderApiRetrievePortfolio1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProviderApi
     */
    public retrievePortfolio1(requestParameters: PortfolioProviderApiRetrievePortfolio1Request = {}, options?: AxiosRequestConfig) {
        return PortfolioProviderApiFp(this.configuration).retrievePortfolio1(requestParameters.portfolioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve real economy positions for customer code grouped by different type (product, product type , duration ...) 
     * @param {PortfolioProviderApiRetrieveRealEconomyPortfolioComposition1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProviderApi
     */
    public retrieveRealEconomyPortfolioComposition1(requestParameters: PortfolioProviderApiRetrieveRealEconomyPortfolioComposition1Request, options?: AxiosRequestConfig) {
        return PortfolioProviderApiFp(this.configuration).retrieveRealEconomyPortfolioComposition1(requestParameters.compositionType, requestParameters.customerCode, requestParameters.jointHolders, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegistrationProviderApi - axios parameter creator
 * @export
 */
export const RegistrationProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate contract
         * @param {ActivateContractRequest} [activateContractRequest] Activate contract registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateContractRegistration1: async (activateContractRequest?: ActivateContractRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registration/activateRegistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateContractRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add verified contact
         * @param {ContactInfoRequest} [contactInfoRequest] Contact information request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addContact1: async (contactInfoRequest?: ContactInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registration/addContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary InformativeAcceptance step registration
         * @param {InformativeVerificationRequest} [informativeVerificationRequest] Privacy acceptance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        informativeAcceptance1: async (informativeVerificationRequest?: InformativeVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registration/privacyPolicy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(informativeVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate contract data
         * @param {PrepareContractRegistrationRequest} [prepareContractRegistrationRequest] Prepare contract registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareContractRegistration1: async (prepareContractRegistrationRequest?: PrepareContractRegistrationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registration/prepareRegistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prepareContractRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accessory user step registration
         * @param {RegistrationAccessoryUserRequest} [registrationAccessoryUserRequest] Accessory user registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAccessoryUser1: async (registrationAccessoryUserRequest?: RegistrationAccessoryUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registration/additionalUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationAccessoryUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve customer agent
         * @param {string} customerCode Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCustomerAgent1: async (customerCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('retrieveCustomerAgent1', 'customerCode', customerCode)
            const localVarPath = `/registration/agent/{customerCode}`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve user personal data
         * @param {string} typeRecipient Recipient type A&#x3D;Agent/C&#x3D;Customer
         * @param {string} code Recipient code
         * @param {string} [behalfOf] Customer Recipient BehalfOf Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePersonalData1: async (typeRecipient: string, code: string, behalfOf?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeRecipient' is not null or undefined
            assertParamExists('retrievePersonalData1', 'typeRecipient', typeRecipient)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('retrievePersonalData1', 'code', code)
            const localVarPath = `/registration/personalData/{typeRecipient}/{code}`
                .replace(`{${"typeRecipient"}}`, encodeURIComponent(String(typeRecipient)))
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (behalfOf !== undefined) {
                localVarQueryParameter['behalfOf'] = behalfOf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve verified phone contact
         * @param {string} customerCode Customer Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePhone1: async (customerCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('retrievePhone1', 'customerCode', customerCode)
            const localVarPath = `/registration/retrieve/phone/{customerCode}`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary start registration process
         * @param {RegistrationFirstStepRequest} [registrationFirstStepRequest] User registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startProcess1: async (registrationFirstStepRequest?: RegistrationFirstStepRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registration/startProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationFirstStepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationProviderApi - functional programming interface
 * @export
 */
export const RegistrationProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate contract
         * @param {ActivateContractRequest} [activateContractRequest] Activate contract registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateContractRegistration1(activateContractRequest?: ActivateContractRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRegistrationBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateContractRegistration1(activateContractRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add verified contact
         * @param {ContactInfoRequest} [contactInfoRequest] Contact information request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addContact1(contactInfoRequest?: ContactInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRegistrationBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addContact1(contactInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary InformativeAcceptance step registration
         * @param {InformativeVerificationRequest} [informativeVerificationRequest] Privacy acceptance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async informativeAcceptance1(informativeVerificationRequest?: InformativeVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRegistrationBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.informativeAcceptance1(informativeVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate contract data
         * @param {PrepareContractRegistrationRequest} [prepareContractRegistrationRequest] Prepare contract registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareContractRegistration1(prepareContractRegistrationRequest?: PrepareContractRegistrationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePrepareContractResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepareContractRegistration1(prepareContractRegistrationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Accessory user step registration
         * @param {RegistrationAccessoryUserRequest} [registrationAccessoryUserRequest] Accessory user registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerAccessoryUser1(registrationAccessoryUserRequest?: RegistrationAccessoryUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRegistrationAccessoryUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerAccessoryUser1(registrationAccessoryUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve customer agent
         * @param {string} customerCode Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveCustomerAgent1(customerCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAgentDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveCustomerAgent1(customerCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve user personal data
         * @param {string} typeRecipient Recipient type A&#x3D;Agent/C&#x3D;Customer
         * @param {string} code Recipient code
         * @param {string} [behalfOf] Customer Recipient BehalfOf Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePersonalData1(typeRecipient: string, code: string, behalfOf?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePersonalDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePersonalData1(typeRecipient, code, behalfOf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve verified phone contact
         * @param {string} customerCode Customer Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePhone1(customerCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRegistrationPhoneResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePhone1(customerCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary start registration process
         * @param {RegistrationFirstStepRequest} [registrationFirstStepRequest] User registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startProcess1(registrationFirstStepRequest?: RegistrationFirstStepRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRegistrationFirstStepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startProcess1(registrationFirstStepRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrationProviderApi - factory interface
 * @export
 */
export const RegistrationProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate contract
         * @param {ActivateContractRequest} [activateContractRequest] Activate contract registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateContractRegistration1(activateContractRequest?: ActivateContractRequest, options?: any): AxiosPromise<ResponseRegistrationBaseResponse> {
            return localVarFp.activateContractRegistration1(activateContractRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add verified contact
         * @param {ContactInfoRequest} [contactInfoRequest] Contact information request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addContact1(contactInfoRequest?: ContactInfoRequest, options?: any): AxiosPromise<ResponseRegistrationBaseResponse> {
            return localVarFp.addContact1(contactInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary InformativeAcceptance step registration
         * @param {InformativeVerificationRequest} [informativeVerificationRequest] Privacy acceptance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        informativeAcceptance1(informativeVerificationRequest?: InformativeVerificationRequest, options?: any): AxiosPromise<ResponseRegistrationBaseResponse> {
            return localVarFp.informativeAcceptance1(informativeVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate contract data
         * @param {PrepareContractRegistrationRequest} [prepareContractRegistrationRequest] Prepare contract registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareContractRegistration1(prepareContractRegistrationRequest?: PrepareContractRegistrationRequest, options?: any): AxiosPromise<ResponsePrepareContractResponse> {
            return localVarFp.prepareContractRegistration1(prepareContractRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accessory user step registration
         * @param {RegistrationAccessoryUserRequest} [registrationAccessoryUserRequest] Accessory user registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAccessoryUser1(registrationAccessoryUserRequest?: RegistrationAccessoryUserRequest, options?: any): AxiosPromise<ResponseRegistrationAccessoryUserResponse> {
            return localVarFp.registerAccessoryUser1(registrationAccessoryUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve customer agent
         * @param {string} customerCode Customer code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCustomerAgent1(customerCode: string, options?: any): AxiosPromise<ResponseAgentDataResponse> {
            return localVarFp.retrieveCustomerAgent1(customerCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve user personal data
         * @param {string} typeRecipient Recipient type A&#x3D;Agent/C&#x3D;Customer
         * @param {string} code Recipient code
         * @param {string} [behalfOf] Customer Recipient BehalfOf Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePersonalData1(typeRecipient: string, code: string, behalfOf?: string, options?: any): AxiosPromise<ResponsePersonalDataResponse> {
            return localVarFp.retrievePersonalData1(typeRecipient, code, behalfOf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve verified phone contact
         * @param {string} customerCode Customer Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePhone1(customerCode: string, options?: any): AxiosPromise<ResponseRegistrationPhoneResponse> {
            return localVarFp.retrievePhone1(customerCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary start registration process
         * @param {RegistrationFirstStepRequest} [registrationFirstStepRequest] User registration request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startProcess1(registrationFirstStepRequest?: RegistrationFirstStepRequest, options?: any): AxiosPromise<ResponseRegistrationFirstStepResponse> {
            return localVarFp.startProcess1(registrationFirstStepRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateContractRegistration1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiActivateContractRegistration1Request
 */
export interface RegistrationProviderApiActivateContractRegistration1Request {
    /**
     * Activate contract registration request
     * @type {ActivateContractRequest}
     * @memberof RegistrationProviderApiActivateContractRegistration1
     */
    readonly activateContractRequest?: ActivateContractRequest
}

/**
 * Request parameters for addContact1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiAddContact1Request
 */
export interface RegistrationProviderApiAddContact1Request {
    /**
     * Contact information request
     * @type {ContactInfoRequest}
     * @memberof RegistrationProviderApiAddContact1
     */
    readonly contactInfoRequest?: ContactInfoRequest
}

/**
 * Request parameters for informativeAcceptance1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiInformativeAcceptance1Request
 */
export interface RegistrationProviderApiInformativeAcceptance1Request {
    /**
     * Privacy acceptance request
     * @type {InformativeVerificationRequest}
     * @memberof RegistrationProviderApiInformativeAcceptance1
     */
    readonly informativeVerificationRequest?: InformativeVerificationRequest
}

/**
 * Request parameters for prepareContractRegistration1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiPrepareContractRegistration1Request
 */
export interface RegistrationProviderApiPrepareContractRegistration1Request {
    /**
     * Prepare contract registration request
     * @type {PrepareContractRegistrationRequest}
     * @memberof RegistrationProviderApiPrepareContractRegistration1
     */
    readonly prepareContractRegistrationRequest?: PrepareContractRegistrationRequest
}

/**
 * Request parameters for registerAccessoryUser1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiRegisterAccessoryUser1Request
 */
export interface RegistrationProviderApiRegisterAccessoryUser1Request {
    /**
     * Accessory user registration request
     * @type {RegistrationAccessoryUserRequest}
     * @memberof RegistrationProviderApiRegisterAccessoryUser1
     */
    readonly registrationAccessoryUserRequest?: RegistrationAccessoryUserRequest
}

/**
 * Request parameters for retrieveCustomerAgent1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiRetrieveCustomerAgent1Request
 */
export interface RegistrationProviderApiRetrieveCustomerAgent1Request {
    /**
     * Customer code
     * @type {string}
     * @memberof RegistrationProviderApiRetrieveCustomerAgent1
     */
    readonly customerCode: string
}

/**
 * Request parameters for retrievePersonalData1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiRetrievePersonalData1Request
 */
export interface RegistrationProviderApiRetrievePersonalData1Request {
    /**
     * Recipient type A&#x3D;Agent/C&#x3D;Customer
     * @type {string}
     * @memberof RegistrationProviderApiRetrievePersonalData1
     */
    readonly typeRecipient: string

    /**
     * Recipient code
     * @type {string}
     * @memberof RegistrationProviderApiRetrievePersonalData1
     */
    readonly code: string

    /**
     * Customer Recipient BehalfOf Code
     * @type {string}
     * @memberof RegistrationProviderApiRetrievePersonalData1
     */
    readonly behalfOf?: string
}

/**
 * Request parameters for retrievePhone1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiRetrievePhone1Request
 */
export interface RegistrationProviderApiRetrievePhone1Request {
    /**
     * Customer Code
     * @type {string}
     * @memberof RegistrationProviderApiRetrievePhone1
     */
    readonly customerCode: string
}

/**
 * Request parameters for startProcess1 operation in RegistrationProviderApi.
 * @export
 * @interface RegistrationProviderApiStartProcess1Request
 */
export interface RegistrationProviderApiStartProcess1Request {
    /**
     * User registration request
     * @type {RegistrationFirstStepRequest}
     * @memberof RegistrationProviderApiStartProcess1
     */
    readonly registrationFirstStepRequest?: RegistrationFirstStepRequest
}

/**
 * RegistrationProviderApi - object-oriented interface
 * @export
 * @class RegistrationProviderApi
 * @extends {BaseAPI}
 */
export class RegistrationProviderApi extends BaseAPI {
    /**
     * 
     * @summary Activate contract
     * @param {RegistrationProviderApiActivateContractRegistration1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public activateContractRegistration1(requestParameters: RegistrationProviderApiActivateContractRegistration1Request = {}, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).activateContractRegistration1(requestParameters.activateContractRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add verified contact
     * @param {RegistrationProviderApiAddContact1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public addContact1(requestParameters: RegistrationProviderApiAddContact1Request = {}, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).addContact1(requestParameters.contactInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary InformativeAcceptance step registration
     * @param {RegistrationProviderApiInformativeAcceptance1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public informativeAcceptance1(requestParameters: RegistrationProviderApiInformativeAcceptance1Request = {}, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).informativeAcceptance1(requestParameters.informativeVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate contract data
     * @param {RegistrationProviderApiPrepareContractRegistration1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public prepareContractRegistration1(requestParameters: RegistrationProviderApiPrepareContractRegistration1Request = {}, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).prepareContractRegistration1(requestParameters.prepareContractRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accessory user step registration
     * @param {RegistrationProviderApiRegisterAccessoryUser1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public registerAccessoryUser1(requestParameters: RegistrationProviderApiRegisterAccessoryUser1Request = {}, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).registerAccessoryUser1(requestParameters.registrationAccessoryUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve customer agent
     * @param {RegistrationProviderApiRetrieveCustomerAgent1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public retrieveCustomerAgent1(requestParameters: RegistrationProviderApiRetrieveCustomerAgent1Request, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).retrieveCustomerAgent1(requestParameters.customerCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve user personal data
     * @param {RegistrationProviderApiRetrievePersonalData1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public retrievePersonalData1(requestParameters: RegistrationProviderApiRetrievePersonalData1Request, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).retrievePersonalData1(requestParameters.typeRecipient, requestParameters.code, requestParameters.behalfOf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve verified phone contact
     * @param {RegistrationProviderApiRetrievePhone1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public retrievePhone1(requestParameters: RegistrationProviderApiRetrievePhone1Request, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).retrievePhone1(requestParameters.customerCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary start registration process
     * @param {RegistrationProviderApiStartProcess1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationProviderApi
     */
    public startProcess1(requestParameters: RegistrationProviderApiStartProcess1Request = {}, options?: AxiosRequestConfig) {
        return RegistrationProviderApiFp(this.configuration).startProcess1(requestParameters.registrationFirstStepRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


